import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import i18n from "i18next";
import {
  getAggregatedData,
  getAggregatedDataWrapper,
  onFilterModelChange,
  renderGrid,
  aggregatedAdministrativeTableColumns,
} from "./AgroAnalyticsUtils";

const aggregatedSpecieGroupTableColumns = () => [
  {
    field: "Anno",
    headerName: i18n.t("agriculture.year"),
    width: 60,
  },

  {
    field: "Compagnia",
    headerName: i18n.t("company"),
    width: 60,
  },

  {
    field: "Specie_Group",
    headerName: "Specie Group",
    width: 120,
  },
  ...aggregatedAdministrativeTableColumns(),
];

export const AgroSpecieGroupGrid = ({ filterModel, wantedReferenceDateProp }) => {
  const { t } = useTranslation();

  const [aggregatedSpecieGroupTableState, setAggregatedSpecieGroupTableState] = useState({
    isLoading: false,
    total: 0,
  });

  const aggregatedSpecieGroupCancelTokenRef = useRef(null);

  const [aggregatedSpecieGroupTableData, setAggregatedSpecieGroupTableData] = useState([]);

  useEffect(() => {
    const getAggregatedSpecieGroupData = async () => {
      return await getAggregatedData(
        setAggregatedSpecieGroupTableState,
        setAggregatedSpecieGroupTableData,
        { aggr: "Specie_Group" },
        filterModel,
        wantedReferenceDateProp,
        aggregatedSpecieGroupCancelTokenRef,
      );
    };
    const getAggregatedSpecieGroupDataWrapper = async () => {
      getAggregatedDataWrapper(aggregatedSpecieGroupCancelTokenRef, getAggregatedSpecieGroupData);
    };
    onFilterModelChange(filterModel, getAggregatedSpecieGroupDataWrapper);
  }, [filterModel, wantedReferenceDateProp]);

  return renderGrid(
    aggregatedSpecieGroupTableColumns(),
    aggregatedSpecieGroupTableData,
    aggregatedSpecieGroupTableState,
    t,
    "Agenzie",
  );
};
